/**
 * Takes object containing booleans and quantities for labels and maps them onto an array of label objects.
 * @param {Object} data
 */
export const makeLabels = (
  data,
  includeDoorOpen = true,
  includeShowInPlay = true,
) => {
  const {
    showOnline,
    showOffline,
    showNonOp,
    online,
    offline,
    nonOp,
    showDoorOpen,
    doorOpen,
    showInPlay,
    inPlay,
  } = data;

  const array = [
    {
      key: "showOnline",
      text: "Online",
      color: "green",
      disabled: !showOnline,
      quantity: online,
    },
    {
      key: "showOffline",
      text: "Offline",
      color: "red",
      disabled: !showOffline,
      quantity: offline,
    },
    {
      key: "showNonOp",
      text: "Pending",
      color: "orange",
      disabled: !showNonOp,
      quantity: nonOp,
    },
  ];

  if (includeDoorOpen) {
    array.push({
      key: "showDoorOpen",
      text: "Door Open",
      color: "blue",
      disabled: !showDoorOpen,
      quantity: doorOpen,
    });
  }

  if (includeShowInPlay) {
    array.push({
      key: "showInPlay",
      text: "In Play",
      color: "purple",
      disabled: !showInPlay,
      quantity: inPlay,
    });
  }

  return array;
};

export const transactionsLabels = [
  {
    text: "Handpays",
    color: "orange",
    disabled: false,
    quantity: "12 (£1,245.35)",
  },
  {
    text: "Refills",
    color: "green",
    disabled: false,
    quantity: "12 (£1,245.35)",
  },
  { text: "Payouts", color: "blue", disabled: false, quantity: "12 (£245.50)" },
  {
    text: "Promo Cash",
    color: "purple",
    disabled: false,
    quantity: "12 (£245.50)",
  },
  {
    text: "M/c Test",
    color: "grey",
    disabled: false,
    quantity: "12 (£245.50)",
  },
  {
    text: "Tickets Redeemed Kiosk",
    color: "black",
    disabled: false,
    quantity: "250 (£11,245.50)",
  },
  {
    text: "Tickets Redeemed CD",
    color: "yellow",
    disabled: false,
    quantity: "250 (£11,245.50)",
  },
];
